import { render } from "./AeracaoAcoes.vue?vue&type=template&id=ecc420d4&scoped=true"
import script from "./AeracaoAcoes.vue?vue&type=script&lang=js"
export * from "./AeracaoAcoes.vue?vue&type=script&lang=js"

import "./AeracaoAcoes.vue?vue&type=style&index=0&id=ecc420d4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecc420d4"]])

export default __exports__